// extracted by mini-css-extract-plugin
export var attribution = "_bb-4";
export var authorName = "_bb-5";
export var quote = "_bb-3";
export var testimonial = "_bb-2";
export var trustedBy = "_bb-0";
export var trustedByLabel = "_bb-1";